
import { Component, Vue } from 'vue-property-decorator';
import { parse, format, isBefore, isSaturday, isSunday } from 'date-fns';
import { SapCustomerPartner } from '@/api/model';
import { SalesOrderAll } from '@/logic/orders/SalesOrderAll';
import DeliveryDates from '@/logic/orders/DeliveryDates';

const datePart = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

@Component
export default class DeliveryDateField extends Vue {
  get cart(): SalesOrderAll {
    return this.$store.state.order.cart;
  }

  get minDate(): Date {
    const country = this.getCountry();
    return datePart(DeliveryDates.getMin(country));
  }

  get maxDate(): Date | undefined {
    const country = this.getCountry();
    const max = DeliveryDates.getMax(country);
    if (max === undefined) {
      return max;
    }
    return datePart(max);
  }

  get orderDeliveryDate(): Date | undefined {
    const dateString = this.$store.state.order.cart.ReqDlvDate;
    if (!dateString) {
      this.setDeliveryDate(this.minDate);
      return this.minDate;
    }
    let date = parse(`${dateString}12+0000`, 'yyyyMMddHHXX', this.minDate);
    if (date instanceof Date && !Number.isNaN(date.getDate())) {
      if (isBefore(date, this.minDate)) {
        date = this.minDate;
      }

      // Weekend check
      if (isSaturday(date)) {
        date = DeliveryDates.addDays(date, 2);
      } else if (isSunday(date)) {
        date = DeliveryDates.addDays(date, 1);
      }

      this.setDeliveryDate(date);
      return date;
    }
    this.setDeliveryDate(this.minDate);
    return this.minDate;
  }

  setDeliveryDate(date: Date) {
    const formatted = format(date, 'yyyyMMdd');
    this.$store.commit('order/setRequestedDeliveryDate', formatted);
  }

  shipToParty(): boolean {
    return !!this.$store.state.order.cart.ShipToParty;
  }

  getCountry(): string | undefined {
    if (!this.cart.ShipToParty) {
      return undefined;
    }
    const shipTo = this.$store.state.order.shipToPartners.find(
      (p: SapCustomerPartner) => p.CustomerNr === this.cart.ShipToParty,
    );

    if (!shipTo.CountryKey) {
      return undefined;
    }
    return shipTo.CountryKey;
  }
}
